import { ReactNode, createContext, useContext } from "react";
import { useFilterReward } from "./filter-reward.hook";

const FilterRewardContext = createContext(
  {} as ReturnType<typeof useFilterReward>
);
export function useFilterRewardContext() {
  return useContext(FilterRewardContext);
}

interface FilterRewardProviderProps {
  children: ReactNode;
}
export function FilterRewardProvider({
  children,
}: FilterRewardProviderProps) {
  return (
    <FilterRewardContext.Provider value={useFilterReward()}>
      {children}
    </FilterRewardContext.Provider>
  );
}